function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.12,
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 6,
  fill: "#D8DAE7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.444 2H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 00-1.748 1.748C2 5.04 2 6.16 2 8.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 001.748 1.748C5.04 22 6.16 22 8.4 22h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748C22 18.96 22 17.84 22 15.6v-4.711M9 11l3 3L22 4",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#D8DAE7"
  }, props), _ref, _ref2);
};

export default SvgTask;